import axios from 'axios'
import { authHeader } from './auth'

export async function getUrlAutologin () {
  const url = processEnvConfig.VUE_APP_HYPER_ESPACE_API_URL + '/digitalbricks/autologin'
  return axios.get(url, { headers: authHeader() }).then((response) => {
    return response.data
  }).catch(error => {
    return { type: 'error', message: error }
  })
}
